import React, { useEffect, useRef, useState } from "react"
import { preventBodyScroll } from "@/utils/helper"
import Modal from "@/components/core/Modal/Modal"
import ImageReel from "@/components/ImageGallery/v2/ImageReel"

const ImageGallery = props => {
  const [showModal, setShowModal] = useState(null)
  const viewBtnRef = useRef()
  const {
    page = "",
    productInfo = {},
    initialImgAlt = "",
    initialImgUrl = "",
    pdpDesktopImage = "",
    productImagesWithResourceTypes = {},
    threeSixtyResourceData = {},
    clickedProductVariant = false,
  } = props

  useEffect(() => {
    preventBodyScroll(showModal)
    if (showModal) document.body.classList.add("image-gallery-modal-opened")
    else if (showModal === false) {
      document.body.classList.remove(
        "scroll-lock",
        "image-gallery-modal-opened"
      )
      viewBtnRef.current.focus()
    }
  }, [showModal])

  const handleModalPopup = () => {
    setShowModal(true)
  }

  const onModalClose = () => {
    setShowModal(false)
  }

  const isHorizontalView = window.innerWidth < 1024

  const eventInfo = JSON.stringify({
    eventAction: page + ":modal:gallery:close",
    eventName: page + "modal:gallery:close",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "close",
    internalLinkPosition: page,
    internalLinkType: page + ":close",
    internalLinkZoneName: page + ":modal:gallery",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })

  return (
    <>
      <ImageReel
        viewBtnRef={viewBtnRef}
        isHorizontal={isHorizontalView}
        {...props}
        initialImgAlt={initialImgAlt}
        initialImgUrl={initialImgUrl}
        pdpDesktopImage={pdpDesktopImage}
        handlePopup={handleModalPopup}
        galleryStackId="image-gallery__image-stack-gallery"
        productImagesWithUrls={productImagesWithResourceTypes}
        threeSixtyResourceData={threeSixtyResourceData}
        clickedProductVariant={clickedProductVariant}
      />

      <Modal
        onModalClose={onModalClose}
        showModal={showModal}
        closeButtonAnalytics={eventInfo}
        analyticsCustomData={productInfo || null}
      >
        <div className="pdp-image-gallery-container">
          <ImageReel
            viewBtnRef={viewBtnRef}
            isPopup={true}
            isHorizontal={true}
            isModel={true}
            {...props}
            handlePopup={handleModalPopup}
            galleryStackId="image-gallery__image-stack-kohler"
            clickedProductVariant={clickedProductVariant}
          ></ImageReel>
        </div>
      </Modal>
    </>
  )
}

export default ImageGallery
